<template>
  <div class="express-query-container">
    <!-- 查询表单区域 -->
    <div class="form-card">
      <el-form :model="form" size="mini" inline>
        <el-form-item label="地址">
          <el-input
            v-model="form.q"
            type="textarea"
            :rows="4"
            placeholder="请输入详细收件地址"
            resize="none"
            class="address-input"
          />
        </el-form-item>

        <el-form-item label="快递公司">
          <el-select
            v-model="form.cpCode"
            placeholder="请选择快递公司"
            class="cp-select"
          >
            <el-option
              v-for="item in cpList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>

          <el-button
            @click="handleQuery"
            type="primary"
            icon="el-icon-search"
            class="query-btn"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 结果展示区域 -->
    <div v-show="showResult" class="result-card">
      <table class="result-table">
        <tbody>
          <tr>
            <th>网点名称</th>
            <td>{{ data.orgName }}</td>
            <th>网点代码</th>
            <td>{{ data.orgCode }}</td>
            <th>状态：</th>
            <td>{{ data.orgStatusText }}</td>
          </tr>
          <tr>
            <th>上级组织</th>
            <td>{{ data.parentid }}</td>
            <th>可达产品</th>
            <td>{{ data.service_products }}</td>
            <th>停派原因：</th>
            <td>{{ data.stop_reason }}</td>
          </tr>
          <tr>
            <th>联系电话</th>
            <td>{{ data.tel.takePhone }}</td>
            <th>客服电话</th>
            <td>{{ data.tel.csPhone }}</td>
            <th>在线客服</th>
            <td>
              <a :href="data.osurl" target="_blank" class="link">点击打开</a>
            </td>
          </tr>
          <tr>
            <th>地址</th>
            <td colspan="5">{{ data.orgAddress }}</td>
          </tr>
          <tr>
            <th>代收货款</th>
            <td>{{ data.paycollect }}</td>
            <th>到付</th>
            <td>{{ data.freightcollect }}</td>
            <th>特殊服务</th>
            <td>{{ data.specialService }}</td>
          </tr>
          <tr>
            <th>三段码</th>
            <td>{{ data.shortaddress }}</td>
            <th>集包地(中心)</th>
            <td>{{ data.concentrated }}</td>
            <th>五级地址</th>
            <td></td>
          </tr>
          <tr>
            <th>派送范围</th>
            <td colspan="5" v-html="data.serveArea"></td>
          </tr>
          <tr>
            <th>特殊范围</th>
            <td colspan="5" v-html="data.specialArea"></td>
          </tr>
          <tr>
            <th>不派送范围</th>
            <td colspan="5" v-html="data.noDeliveryArea"></td>
          </tr>
          <tr>
            <th>服务时间</th>
            <td>09:00-17:30</td>
            <th>备注</th>
            <td colspan="3"></td>
          </tr>
          <tr>
            <th>修改时间</th>
            <td colspan="5">{{ data.creation_time }}</td>
          </tr>
          <tr>
            <th>地图</th>
            <td colspan="5">
              <div id="allmap" class="map-container"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, onUnmounted, onUpdated } from 'vue'
import { ElMessage, ElLoading } from 'element-plus'

// 定义响应式数据
const form = reactive({
  cpCode: '',
  q: ''
})

const cpList = ref([
  { value: 'YTO', label: '圆通速递' }
  // 可扩展其他快递公司
  // { value: 'ZTO', label: '中通快递' },
  // { value: 'STO', label: '申通快递' },
  // { value: 'YD', label: '韵达快递' },
  // { value: 'JT', label: '极兔速递' }
])

const showResult = ref(false)
const mapConfig = reactive({
  lng: 116.404,
  lat: 39.915,
  instance: null, // 地图实例
  BMap: null      // 百度地图对象
})

const data = reactive({
  orgCode: '',
  orgName: '初始数据',
  orgAddress: '初始数据',
  orgStatusText: '',
  paycollect: '',
  freightcollect: '',
  handlerName: '',
  msn: '',
  text_version_tel: '',
  serveArea: '',
  noDeliveryArea: '',
  specialArea: '',
  selfArea: '',
  specialService: '',
  dispatchout: '',
  shortaddress: '',
  creation_time: '',
  tel: {},
  stop_reason: '',
  service_products: '',
  parentid: '',
  osurl: '',
  concentrated: '',
  location: { lng: 116.404, lat: 39.915 } // 默认坐标
})

// 百度地图加载相关方法
const loadBaiduMap = () => {
  return new Promise((resolve, reject) => {
    // 避免重复加载
    if (window.BMap) {
      mapConfig.BMap = window.BMap
      resolve()
      return
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src =
      'https://api.map.baidu.com/getscript?v=3.0&ak=fXwgHBEgNI3oKCdg8l0934NYeXrTwOeg&services=&t=20220525214710'
    script.onload = () => {
      mapConfig.BMap = window.BMap
      // 加载自定义信息框插件
      loadInfoBoxScript().then(resolve).catch(reject)
    }
    script.onerror = () => reject(new Error('百度地图加载失败'))
    document.body.appendChild(script)
  })
}

const loadInfoBoxScript = () => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = '/infobox.js'
    script.onload = resolve
    script.onerror = () => reject(new Error('信息框插件加载失败'))
    document.body.appendChild(script)
  })
}

// 初始化地图
const initMap = () => {
  if (!mapConfig.BMap) return
  
  // 创建地图实例
  mapConfig.instance = new mapConfig.BMap.Map('allmap')
  // 设置中心点和缩放级别
  const point = new mapConfig.BMap.Point(mapConfig.lng, mapConfig.lat)
  mapConfig.instance.centerAndZoom(point, 18)
  // 添加交通图层
  const traffic = new mapConfig.BMap.TrafficLayer()
  mapConfig.instance.addTileLayer(traffic)
  // 启用滚轮缩放
  mapConfig.instance.enableScrollWheelZoom(true)
  // 添加控件
  mapConfig.instance.addControl(new mapConfig.BMap.NavigationControl())
  mapConfig.instance.addControl(new mapConfig.BMap.ScaleControl())
  mapConfig.instance.addControl(new mapConfig.BMap.OverviewMapControl())
  // 设置地图样式
  mapConfig.instance.setMapStyleV2({
    styleId: '30f6dbd8fbbc6addb642903e64956282'
  })
}

// 添加地图标记和信息框
const addMarker = () => {
  if (!mapConfig.instance || !mapConfig.BMap) return
  
  const point = new mapConfig.BMap.Point(mapConfig.lng, mapConfig.lat)
  // 创建标记
  const marker = new mapConfig.BMap.Marker(point, {
    icon: new mapConfig.BMap.Icon('/logo.ico', new mapConfig.BMap.Size(45, 38))
  })
  mapConfig.instance.addOverlay(marker)
  // 添加跳动动画
  marker.setAnimation(mapConfig.BMap.BMAP_ANIMATION_BOUNCE)
  
  // 信息框内容
  const infoHtml = `
    <div class="infoBoxContent" style="padding: 0.4rem;"> 
      <div>
        <img style="position: relative;width:9%;top:0.15em;object-fit: cover;object-position: 50% 20%;left:2%;" src='/logo.ico' />
        <span style="position: relative;left: 4%;top: -0.2EM;font-size: 1.1em;color: #333333;">${data.orgName}</span>
      </div>
      <div style="position: absolute;left: 5%;top: 38%;font-size: 1em;color: #555555;">
        <span>电话：${data.tel.csPhone || '暂无'}</span>
        <br />
        <span>地址：${data.orgAddress || '暂无'}</span>
      </div>
    </div>
  `
  
  // 点击标记显示信息框
  marker.addEventListener('click', () => {
    if (!window.BMapLib?.InfoBox) return
    
    const infoBox = new window.BMapLib.InfoBox(mapConfig.instance, infoHtml, {
      boxStyle: {
        background: '#fff',
        width: '17rem',
        height: '7rem',
        border: '0px solid #6696ffeb',
        borderRadius: '1em',
        left: '1rem',
        top: '4.4rem'
      },
      closeIconMargin: '0.6em 0.6em 0 0',
      closeIconUrl: 'https://api.map.baidu.com/images/iw_close1d3.gif',
      enableAutoPan: true,
      align: window.BMapLib.INFOBOX_AT_TOP
    })
    infoBox.open(marker)
  })
}

// 查询方法
const handleQuery = async () => {
  // 校验参数（修复原有逗号运算符的错误）
  if (!form.cpCode || !form.q.trim()) {
    ElMessage.error('请选择快递公司并输入关键词')
    return
  }

  // 显示加载
  const loading = ElLoading.service({
    lock: true,
    text: '查询中',
    spinner: 'el-icon-loading',
    background: 'rgba(105, 105, 105, 0.7)'
  })

  try {
    // 发起请求（替换为你的实际接口地址）
    const res = await fetch('', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        modules: 'orgInfo',
        content: {
          cpCode: form.cpCode,
          q: form.q.trim()
        }
      })
    })

    const result = await res.json()
    
    if (result.code === 0) {
      // 更新数据
      Object.assign(data, result.data)
      // 更新地图坐标
      mapConfig.lng = result.data.location?.lng || mapConfig.lng
      mapConfig.lat = result.data.location?.lat || mapConfig.lat
      // 重新初始化地图
      initMap()
      // 添加标记
      addMarker()
      // 显示结果
      showResult.value = true
    } else {
      ElMessage.error(result.msg || '查询失败，请重试')
    }
  } catch (error) {
    console.error('查询出错：', error)
    ElMessage.error('网络异常，查询失败')
  } finally {
    // 关闭加载
    loading.close()
  }
}

// 生命周期钩子
onMounted(async () => {
  try {
    // 加载百度地图
    await loadBaiduMap()
    // 初始化默认地图
    initMap()
  } catch (error) {
    console.error('地图加载失败：', error)
    ElMessage.warning('地图加载失败，不影响查询功能')
  }
})

// 组件卸载时清理地图实例
onUnmounted(() => {
  if (mapConfig.instance) {
    mapConfig.instance.clearOverlays() // 清除覆盖物
    mapConfig.instance = null
  }
})

// 数据更新时重新渲染标记
onUpdated(() => {
  if (showResult.value) {
    addMarker()
  }
})
</script>

<style scoped>
.express-query-container {
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

/* 表单卡片样式 */
.form-card {
  background-color: #fff;
  padding: 2%;
  margin-bottom: 10px;
}

.address-input {
  width: 40vw !important;
  min-width: 300px;
}

.cp-select {
  width: 200px;
  margin-right: 20px;
}

.query-btn {
  vertical-align: bottom;
}

/* 结果卡片样式 */
.result-card {
  background-color: #fff;
  margin-top: 1vh;
  padding: 2% 4%;
}

.result-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
}

.result-table th,
.result-table td {
  border: 1px solid #ebebeb;
  text-align: center;
  font-family: sans-serif;
  padding: 0.4rem;
}

.result-table th {
  width: 10%;
  background-color: #f5f5f5;
}

.result-table td {
  width: 15%;
}

/* 链接样式 */
.link {
  text-decoration: none;
  color: #409eff;
}

.link:hover {
  color: #66b1ff;
}

/* 地图容器 */
.map-container {
  width: 100%;
  height: 24rem;
  overflow: hidden;
  margin: 0;
  font-family: "微软雅黑";
}

/* 响应式适配 */
@media (max-width: 768px) {
  .address-input {
    width: 80vw !important;
  }
  
  .result-table th,
  .result-table td {
    padding: 0.2rem;
    font-size: 12px;
  }
  
  .map-container {
    height: 18rem;
  }
}
</style>